const binding = { modules: {}, dataActions: {} };

    (binding.modules['dyn-script-injector'] = {
        c: () => require('partner/modules/dyn-script-injector/dyn-script-injector.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'dyn-script-injector',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/dyn-script-injector'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|dyn-script-injector|dyn-script-injector'] = {
                c: () => require('partner/modules/dyn-script-injector/dyn-script-injector.view.tsx'),
                cn: '__local__-__local__-dyn-script-injector'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };